
import React from 'react';
import { Instagram, MessageCircle, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SOCIALS } from '../constants';



const Footer: React.FC = () => {
  return (
    <footer className="bg-brand-cream pt-24 pb-12 border-t border-brand-black/5">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-16 mb-20">
          
          <div className="md:col-span-4 space-y-8">
            <img src="https://fbaptclwziljpmozftiz.supabase.co/storage/v1/object/public/images/logo.jpeg" alt="R&C Essentials" className="w-24 mix-blend-multiply" />
            <p className="max-w-sm leading-relaxed text-brand-black/70">
              <span className="block font-serif text-xl italic tracking-wide text-brand-black">
                Le meilleur de Bath & Body Works
              </span>
              <span className="block mt-2 text-sm font-light italic">
                Des essentiels qui marquent, des rituels qui restent.
              </span>
            </p>
            <div className="flex gap-4">
               <a href={SOCIALS.instagram.url} className="p-3 bg-brand-offwhite rounded-full text-brand-gold hover:bg-brand-gold hover:text-brand-offwhite transition-all shadow-sm border border-brand-black/5"><Instagram size={18}/></a>
            </div>
          </div>

          <div className="md:col-span-4 grid grid-cols-2 gap-8">
             <div className="space-y-6">
                <h4 className="text-[9px] uppercase tracking-[0.2em] font-bold text-brand-gold">Produits</h4>
                <ul className="space-y-4 text-[10px] font-bold text-brand-black/50 tracking-widest uppercase">
                  <li><Link to="/shop?category=Brumes Parfumées" className="hover:text-brand-black luxury-transition">Brumes</Link></li>
                  <li><Link to="/shop?category=Lave-mains" className="hover:text-brand-black luxury-transition">Savons</Link></li>
                  <li><Link to="/shop?category=Crèmes Mains" className="hover:text-brand-black luxury-transition">Crèmes</Link></li>
                  <li><Link to="/shop?category=Gels Antiseptiques" className="hover:text-brand-black luxury-transition">Gels</Link></li>
                  <li><Link to="/shop?category=Room Sprays" className="hover:text-brand-black luxury-transition">Room Sprays</Link></li>
                </ul>
             </div>
             <div className="space-y-6">
                <h4 className="text-[9px] uppercase tracking-[0.2em] font-bold text-brand-gold">Réseaux</h4>
                <ul className="space-y-4 text-[10px] font-bold text-brand-black/50 tracking-widest uppercase">
                  <li><a href={SOCIALS.instagram.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-black transition-colors">Instagram <ArrowUpRight size={8}/></a></li>
                  <li><a href={SOCIALS.tiktok.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-black transition-colors">TikTok <ArrowUpRight size={8}/></a></li>
                  <li><a href={SOCIALS.snapchat.url} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-brand-black transition-colors">Snapchat <ArrowUpRight size={8}/></a></li>
                </ul>
             </div>
          </div>

          <div className="md:col-span-4">
             {/* Carte contact */}
             <div className="bg-brand-offwhite p-10 rounded-[2rem] border border-brand-black/5 backdrop-blur-sm">
                <h4 className="text-[9px] uppercase tracking-[0.3em] font-bold text-brand-black mb-6">Service Client</h4>
                <a 
                  href={`https://wa.me/${SOCIALS.whatsapp.number}`} 
                  className="flex items-center gap-4 group"
                >
                   {/* Retour au vert WhatsApp (#25D366) */}
                   <div className="bg-[#25D366] text-white p-4 rounded-full group-hover:scale-110 luxury-transition shadow-lg shadow-green-500/20">
                      <MessageCircle size={22} />
                   </div>
                   <div>
                      <p className="text-sm font-bold text-brand-black uppercase tracking-widest">Conciergerie WhatsApp</p>
                      <p className="text-[8px] uppercase tracking-[0.2em] text-brand-gold font-bold mt-1">Cliquez pour commander</p>
                   </div>
                </a>
             </div>
          </div>
        </div>

        <div className="pt-10 border-t border-brand-black/5 flex flex-col md:flex-row justify-between items-center text-[8px] text-brand-black/40 uppercase tracking-widest font-bold">
          <p>© 2026 R & C ESSENTIALS. Tous droits réservés.</p>
          <div className="flex space-x-12 mt-6 md:mt-0 opacity-50">
             <span>L'art de l'essentiel</span>
             <Link to="/admin" className="hover:text-brand-gold transition-colors">Admin Portal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;